const {
  GRADE_TYPES: {
    FREE_FORM,
    PERCENTAGE,
    RUBRIC,
    PASS_FAIL,
    LETTER_GRADE,
    POINTS,
  },
  PASS_FAIL_ITEMS,
  LETTER_GRADES,
} = require('./constants');

const validateFreeform = grade => ({
  valid: !!grade && typeof grade === 'string',
});

const validatePassFail = grade => ({
  valid: !!PASS_FAIL_ITEMS[grade],
});

const validateRubric = ({ grade, rubric }) => {
  const valueType = typeof grade;
  return {
    valid: !!rubric && (valueType === 'undefined' || valueType === 'number'),
  };
};

const validatePercentage = (grade) => {
  const isNumeric = typeof grade === 'number';

  const isInRange = grade >= 0 && grade <= 100;

  const hasFractionalParts = String(grade).includes('.');

  return {
    valid: isNumeric && isInRange && !hasFractionalParts,
  };
};

const validatePercentageRubric = ({ grade, rubric }) => ({
  valid: !!rubric
    && rubric.gradeType === PERCENTAGE // gradeType must be percentage
    && (
      typeof grade === 'undefined' // grade can be undefined
      || validatePercentage(grade).valid // or percentage
    ),
});

const validatePoints = ({ grade, maxGrade }) => {
  const isNumeric = typeof grade === 'number';
  const isInRange = grade >= 0 && grade <= maxGrade;
  const hasFractionalParts = String(grade).includes('.');
  return {
    valid: isNumeric && isInRange && !hasFractionalParts,
  };
};

const validateGrade = ({ grade, rubric, gradeType, maxGrade }) => {
  if (!gradeType) {
    return rubric
      ? validateRubric({ grade, rubric })
      : validateFreeform(grade);
  }

  switch (gradeType) {
  case PERCENTAGE:
    return validatePercentage(grade);
  case FREE_FORM:
    return validateFreeform(grade);
  case PASS_FAIL:
    return validatePassFail(grade);
  case POINTS:
    return validatePoints({ grade, maxGrade });
  case RUBRIC:
    if (!rubric) {
      return { valid: false };
    }
    if (!rubric.gradeType) { // legacy rubric
      return validateRubric({ grade, rubric });
    }
    return validatePercentageRubric({ grade, rubric });
  case LETTER_GRADE:
    return { valid: LETTER_GRADES.includes(grade) };
  default:
    return { valid: false };
  }
};

module.exports = validateGrade;
